import { apiRequest } from './apiClient';

export const getFiles = async () => {
  return apiRequest('/files');
};

export const getFile = async (id) => {
  return apiRequest(`/files/${id}`);
};

export const createFile = async (fileData) => {
  return apiRequest('/files', { method: 'POST', body: fileData, modelLabel: 'ficha' });
};

export const updateFile = async (id, fileData) => {
  return apiRequest(`/files/${id}`, { method: 'PUT', body: fileData, modelLabel: 'ficha' });
};

export const deleteFile = async (id) => {
  return apiRequest(`/files/${id}`, { method: 'DELETE', modelLabel: 'ficha' });
};

export const getServicesByFile = async (fileId) => {
  return apiRequest(`/files/${fileId}/services`);
};

export const createServiceForFile = async (fileId, serviceData) => {
  return apiRequest(`/files/${fileId}/services`, { method: 'POST', body: serviceData, modelLabel: 'servicio' });
};

export const updateService = async (serviceId, serviceData) => {
  return apiRequest(`/services/${serviceId}`, { method: 'PUT', body: serviceData, modelLabel: 'servicio' });
};

export const deleteService = async (serviceId) => {
  return apiRequest(`/services/${serviceId}`, { method: 'DELETE', modelLabel: 'servicio' });
};

export const getPaymentsByFile = async (fileId) => {
  return apiRequest(`/files/${fileId}/payments`);
};

export const createPaymentForFile = async (fileId, paymentData) => {
  return apiRequest(`/files/${fileId}/payments`, { method: 'POST', body: paymentData, modelLabel: 'pago' });
};

export const updatePayment = async (paymentId, paymentData) => {
  return apiRequest(`/payments/${paymentId}`, { method: 'PUT', body: paymentData, modelLabel: 'pago' });
};

export const deletePayment = async (paymentId) => {
  return apiRequest(`/payments/${paymentId}`, { method: 'DELETE', modelLabel: 'pago' });
};

export const getPassengersByFile = async (fileId) => {
  return apiRequest(`/files/${fileId}/passengers`);
};

export const addPassengerToFile = async (fileId, passengerId) => {
  return apiRequest(`/files/${fileId}/passengers`, {
    method: 'POST',
    body: { passengerId },
    modelLabel: 'pasajero',
  });
};

export const removePassengerFromFile = async (fileId, passengerId) => {
  return apiRequest(`/files/${fileId}/passengers/${passengerId}`, {
    method: 'DELETE',
    modelLabel: 'pasajero',
  });
};
